import ky from "ky";

import { useOpenAiStore } from "../stores/openai";

export const ky302 = ky.create({
  prefixUrl: import.meta.env.VITE_PUBLIC_API_URL,
  // eslint-disable-next-line unicorn/numeric-separators-style
  timeout: 120000,
  hooks: {
    beforeRequest: [
      (request) => {
        const apiKey = useOpenAiStore.getState().apiKey;

        if (apiKey) {
          // eslint-disable-next-line lingui/no-unlocalized-strings
          request.headers.set("Authorization", `Bearer ${apiKey}`);
        }
      },
    ],
    afterResponse: [],
  },
});

export const ky302Official = ky.create({
  prefixUrl: import.meta.env.VITE_PUBLIC_API_OFFICIAL_URL,
  // eslint-disable-next-line unicorn/numeric-separators-style
  timeout: 100000,
  hooks: {
    beforeRequest: [
      (request) => {
        const apiKey = useOpenAiStore.getState().apiKey;

        if (apiKey) {
          // eslint-disable-next-line lingui/no-unlocalized-strings
          request.headers.set("Authorization", `Bearer ${apiKey}`);
        }
      },
    ],
    afterResponse: [],
  },
});

export const kyParent = ky.create({
  // prefixUrl: "./",
  // eslint-disable-next-line unicorn/numeric-separators-style
  timeout: 100000,
  hooks: {
    beforeRequest: [],
    afterResponse: [],
  },
});
